// extracted by mini-css-extract-plugin
export default {"item":"item_item__n0+tf","label":"item_label__1ERth","icon":"item_icon__frwSY"};